// ./src/redux/actions/userActions.js
import { Toast } from 'react-bootstrap';
import * as userService from '../../services/userServices';
import { addToast } from './authActions';

// Thunk action to fetch users
export const fetchUsers = ({ search, page }) => async (dispatch) => {
  try {
    const data = await userService.fetchUsers(search, page);
    dispatch({ type: 'FETCH_USERS_SUCCESS', payload: data });
  } catch (error) {
    console.error('Error fetching users', error);
    // Optionally, dispatch an error toast here
  }
};

export const fetchUserById = (userId) => async (dispatch) => {
  try {
    const data = await userService.fetchUserById(userId);
    dispatch({ type: 'FETCH_USER_SUCCESS', payload: data });
  } catch (error) {
    console.error('Error fetching user', error);
  }
};

export const updateUser = (userData) => async (dispatch) => {
  try {
    await userService.updateUser(userData);
    dispatch({ type: 'UPDATE_USER_SUCCESS' });
    // Optionally, refresh the user list or show a success toast
  } catch (error) {
    console.error('Error updating user', error);
  }
};

export const createUser = (userData) => async (dispatch) => {
  try {
    const response = await userService.createUser(userData);
    // Optionally, refresh the user list or show a success toast
    return { success: true, data: response }
  } catch (error) {
    if (error.response && error.response.status === 403) {
      console.log(error)
      // validation error
      dispatch(addToast({ message: error.response.data.error, variant: 'danger' }));
      return { error };
    }
    if (error.response && error.response.status === 409) {
      // duplicate email error
      dispatch(addToast({ message: error.response.data.error, variant: 'danger' }));
      console.log(error)
      return { error };
    } else {
    console.error('Error creating user', error);
    }
  }
};


export const deleteUser = (userId) => async (dispatch) => {
  try {
    const response = await userService.deleteUser(userId);
    // Optionally, dispatch an action to remove the user from state
    return response;
  } catch (error) {
    dispatch(addToast({
      id: Date.now(),
      message: error.response.data.error,
      variant: 'danger'
    }));
    console.error('Error deleting user', error);
  }
};

/**
 * Change password action:
 * For regular users, currentPassword is required.
 * For admin/superUser changing another user's password, currentPassword may be omitted.
 */
export const changePassword = (userId, { currentPassword, newPassword }) => async (dispatch) => {
  try {
    await userService.changeUserPassword(userId, newPassword, currentPassword);
    dispatch(addToast({
        id: Date.now(),
        message: 'Password changed successfully.',
        variant: 'success'
      }));
    // Optionally, dispatch a success toast message here
  } catch (error) {
    console.error('Error changing password', error);
  }
};

export const fetchPermissions = () => async (dispatch) => {
  try {
    const data = await userService.fetchPermissions();
    // Optionally, dispatch an action to store permissions in Redux
    return data;
  } catch (error) {
    console.error('Error fetching permissions', error);
  }
};

export const setSelectedUser = (user) => ({
  type: 'SET_SELECTED_USER',
  payload: user,
});

export const clearSelectedUser = () => ({
  type: 'CLEAR_SELECTED_USER',
});